import React, { FC } from 'react'

import { Specialities } from './Specialities'
import { Subjects } from './Subjects'
import { Difficulty } from './Difficulty'
import { Pim } from './PIM'
import { Wrapper } from './style'

import { ISpecData, ISubjData, OrgType, ISubj, IPim } from '@/types/fepoPages'

type Props = {
  project: 'fepo' | 'training'
  orgType: OrgType
  specId: number
  specialities: ISpecData
  subjs: ISubjData
  subjId: number
  pimId: number,
  actions
}

export const FepoStruct: FC<Props> = ({
  project,
  orgType = 'vuz',
  specId,
  specialities = {},
  subjs = {},
  subjId,
  pimId,
  actions
}) => {
  let selectedSubj: ISubj | undefined
  selectedSubj = subjs.subjects?.find(s => s.id === subjId)

  const selectedSpec = specialities[orgType]?.find(s => s.id === specId)
  const specName: string | undefined = selectedSpec?.name

  const generalCycleId = 18 // Цикл общеобразовательных дисциплин
  const isGeneral = selectedSubj?.cycleId === generalCycleId ? true : false

  const pimsForSelectedSubject = subjs.pims?.reduce((memo: Array<IPim>, pim: IPim) => {
    return pim.subjectId === subjId
      ? [...memo, pim]
      : memo
  }, [])

  return (
    <Wrapper>
      <p>{`
        Для ознакомления со структурой ПИМ выберите уровень образования,
        направление подготовки / специальность / профессию, дисциплину${project === 'fepo' ? ', трудоемкость и способ формирования ПИМ (с конструированием или без конструирования)' : ''}.
      `}</p>

      <Specialities />

      <Subjects
        alternativeNames={selectedSubj?.alternativeNames}
        isGeneral={isGeneral}
        subjName={selectedSubj?.name}
        specName={specName}
      />

      {!!subjId &&
        <>
          {project === 'fepo' &&
            <>
              <Difficulty
                pims={pimsForSelectedSubject}
                pimId={pimId}
                name={selectedSubj?.name}
                subjectId={subjId}
                mypageUrl={specialities.mypageURL}
                actions={actions}
                hidden={isGeneral}
              />

              <Pim
                isGeneral={isGeneral}
                subjectName={selectedSubj?.name}
              />
            </>
          }
        </>
      }
    </Wrapper >
  )
}

